import Cookie from 'js-cookie'
import wpkReporter from 'wpk-reporter' // 导入基础sdk
import wpkglobalerrorPlugin from 'wpk-reporter/dist/plugins/globalerror'
import wpkperformancePlugin from 'wpk-reporter/dist/plugins/performance'

/**
 * 字段说明：agent_num、vcc_code 两个字段用户中心统一写入到了cookie中
 *
 * bid: 是监控系统的唯一id。
 *
 * beforeSend：上报前的自定义数据处理
 *    --uid：用户标识，统一用坐席工号(agent_num)
 *    --c1：自定义字段，统一设置为模块名称(git仓库中的项目名)
 *    --c2：自定义字段，统一设置为企业编码(vcc_code)
 */

let customConfig = {
  bid: '',
  moduleName: '未定义',
  formanceEnable: true,
  openApi: false
}

const Config = {
  bid: '', // 新建应用时确定
  spa: true,  // 单页应用开启后，可更准确地采集PV
  uid: () => {
    const agent_num = Cookie.get('agent_num') || ''
    return agent_num
  },
  plugins: [
    [wpkglobalerrorPlugin, {
      jsErr: true, // 是否开启JS error监控
      resErr: true, // 是否开启资源异常监控
      jsErrFilter: function (event) {
        let { message = "", target: { location: { href = "" } = {} } = {}, reason = {} } = event || {};
        let { message: msg } = reason
        const regex = /https:\/\/goo\.gl\/LdLk22/;
        if (/play\(\)/.test(msg) || regex.test(msg) || /Network Error/.test(msg) || /Permission denied/.test(msg) || /Requested device not found/.test(msg) | /timeout of 10000ms exceeded/.test(msg) || /Failed status transition/.test(msg)) {
          return false
        }
        // 根据你自身业务需要进行过滤
        return true // 返回true，则上报日志，返回false，丢弃日志
      }

    }],
    [wpkperformancePlugin, {
      enable: customConfig.formanceEnable
    }]
  ],
  beforeSend: (logData) => {
    const vcc_code = Cookie.get('vcc_code') || ''
    const { moduleName = '' } = customConfig || {}

    logData.c1 = moduleName;
    logData.c2 = vcc_code

    return true
  }
}

// 监控实例
let __wpk = null

// 初始化监控
const initWpk = (ac_config = {}) => {
  customConfig = {
    ...customConfig,
    ...ac_config
  }

  if (customConfig.openApi) {
    Config.plugins = []
  }

  Config.bid = customConfig.bid
  if (!Config.bid) {
    console.log('bid不能为空，请确认参数')
    return false
  }
  __wpk = new wpkReporter(Config)
  __wpk.install()
}

export default {
  __wpk,
  initWpk
}




// WEBPACK FOOTER //
// ./src/wpk/index.js